<style>

.home .section-shaped .shape-style-1.shape-primary.wsu {
    /* uigradients.com */
    background: #042D98;
    background-image: url('./../assets/img/vortex.jpg');
    background-repeat: no-repeat;
    background-position: left;
    background-size: cover;
    -webkit-box-shadow: 0px 1px 23px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 1px 23px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 1px 23px 0px rgba(0, 0, 0, 0.75);
}

.home .title {
    color: #e0e1e2;
}

.home .subtitle {
    color: #e0e1e2;
}

.home .btn-filter,
.home .btn-reset {
    margin-top: -35px;
}

.home .fade-enter-active,
.home .fade-leave-active {
    transition: opacity .5s;
}

.home .fade-enter,
.home .fade-leave-to {
    opacity: 0;
}

.home .section-filter .badge {
    text-transform: none !important;
    background-color: #fff !important;
    color: #828282 !important;
    opacity: 0.8;
    filter: alpha(opacity=80);
    /* For IE8 and earlier */
    margin: 0 3px 3px 0;
}

.home .btn-badge,
.home .badge {
    -webkit-border-radius: 10rem !important;
    -moz-border-radius: 10rem !important;
    border-radius: 10rem !important;
}

.home #search {
    font-size: 1.3rem!important;
}

.home #range-date-btn {
    margin-top: 35px;
}

.home #filter-categories .card-header {
    padding: 0;
}

.home #filter-categories .nav-link {
    -webkit-border-radius: 0px;
    -moz-border-radius: 0px;
    border-radius: 0px;
    padding: 1rem;
}

.home .btn-xs {
    font-size: 0.6rem !important;
    padding: 0.2rem 0.3rem!important;
}

.home .section-shaped .btn-badge.btn-danger:hover {
    background-color: #f5365c;
    border-color: #f5365c;
}

.home .card.post {
    border-color: #888787;
}

.home .card.card-post {
    box-shadow: 0 0 5px #cccccc;
    font-size: 1rem;
}

.home .card.card-post .card-header {
    font-size: 80%;
    font-weight: 600;
    line-height: 1;
}

.home .card.card-post .card-header,
.home .card.card-post .card-footer {
    padding: 0.75rem 1.0rem;
    background: #ffffff;
}

.home .card.card-post .card-body {
    padding: 0 1rem;
    margin: 1rem 0;
    min-height: 80px;
    width: 100%;
    display: flex;
    align-items: center;
    -webkit-align-items: center;
    justify-content: center;
    -webkit-justify-content: center;
    max-lines: 3;
    text-overflow: -o-ellipsis;
    word-wrap: break-word;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}

.home .posts {
    min-height: 500px;
}

.home .features .card-body,
.home .posts .card-body {
    padding: 0 1rem;
    margin: 0.25rem 0;
    min-height: 110px;
    width: 100%;
    display: flex;
    align-items: justify;
    -webkit-align-items: center;
    justify-content: center;
    -webkit-justify-content: center;
    max-lines: 4;
    text-overflow: -o-ellipsis;
    word-wrap: break-word;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
}

.home .features .card-body a,
.home .posts .card-body a {
    /*color: #2b2b2b;*/
}

.home .features .card-footer,
.home .posts .card-footer {
    padding: 0.25rem 1rem;
    font-size: 80%;
}

.home .card.card-post .card-body a {
    color: #2b2b2b;
}

.home .card.card-post .card-footer {
    padding: 0 0.2rem;
}

.home .card.card-post .card-footer .tags {
    margin: 0;
    min-height: 65px;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    -webkit-align-items: center;
    justify-content: center;
    -webkit-justify-content: center;
    max-lines: 3;
    text-overflow: -o-ellipsis;
    word-wrap: break-word;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}

.home .card.card-post .card-footer .badge {
    text-transform: none !important;
    color: #ffffff !important;
    margin: 0 3px 3px 0;
    padding: 0.2rem 0.3rem;
    font-size: 60%;
    cursor: pointer;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=70)";
    filter: alpha(opacity=70);
    -moz-opacity: 0.7;
    -khtml-opacity: 0.7;
    opacity: 0.7;
}

.home .no-data i {
    font-size: 11rem;
}

.home .btn-filter {
    margin-top: -35px;
}

.home .section-posts {
    min-height: 800px;
}

.home .categories p,
.home .categories i.fa {
    color: #fff;
}

.home .categories i.fa {
    font-size: 3.5rem;
}

.home .categories .category {
    cursor: pointer;
}

.home .categories .category:hover {
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=34)";
    filter: alpha(opacity=90);
    -moz-opacity: 0.90;
    -khtml-opacity: 0.90;
    opacity: 0.90;
}

.home .posts .card-header {
    background-color: #fff!important;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
}

.home .features .card-header {
    background-color: #fff;
}

.home .features {
    background-color: #f6f9fc;
}

.home .cursor-pointer {
    cursor: pointer;
}

.home .btn-more-details {
    margin-top: -45px;
}

@media(max-width:575px) {
    .home .btn-reset,
    .home .bottom-btn-form-not-xs {
        display: none;
    }
}

@media(min-width:576px) and (max-width:767px) {
    .home .btn-reset,
    .home .bottom-btn-form-not-xs {
        display: none;
    }
}

@media(min-width:768px) and (max-width:991px) {
    .home .bottom-btn-form-xs {
        display: none;
    }
}

@media(min-width:992px) and (max-width:1199px) {
    .home .bottom-btn-form-xs {
        display: none;
    }
}

@media(min-width:1200px) {
    .home .bottom-btn-form-xs {
        display: none;
    }
}

</style>

<template>

<div class="home">
    <go-top bg-color="#3B7FF6"></go-top>
    <section class="section section-shaped my-0 pb-3">
        <div class="shape shape-style-1 shape-primary wsu">
        </div>
        <div class="container pt-3">
            <div class="row my-0 py-0">
                <div class="col-lg-12">
                    <h1 class="title text-center my-0 py-0"><center>EDUCATIONAL DATABASE</center></h1>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-2">&nbsp;</div>
                <div class="col-lg-8">
                    <p class="subtitle" v-html="subtitle"></p>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-1">&nbsp;</div>
                <div class="col-lg-8">
                    <base-input id="search" v-model="terms" v-on:keyup.enter="onEnterClick" alternative placeholder="Search here ..."></base-input>
                </div>
                <div class="col-lg-2 text-left">
                    <base-button class="btn-block btn-3" type="primary" v-on:click="onEnterClick">Search</base-button>
                </div>
            </div>
            <div v-if="categories" class="row pt-1 pb-3">
                <div class="col-lg-12 text-center">
                    <template v-for="(value, key) in categories">
                        <template v-for="i in value">
                            <template v-if="i.name.toLowerCase() != 'all'">
                                <template v-if="key != 'language'">
                                    <base-button class="btn-badge my-1" size="sm" type="primary" icon="fa fa-times-circle" v-if="is_filter_checked(key,i.name)" v-on:click="filter_remove(key,i.name)">{{i.name}}</base-button>
                                </template>
                                <template v-if="key == 'language'">
                                    <base-button class="btn-badge my-1" size="sm" type="primary" icon="fa fa-times-circle" v-if="is_filter_checked(key,i.display_name)" v-on:click="filter_remove(key,i.display_name)">{{i.display_name}}</base-button>
                                </template>
                            </template>
                        </template>
                    </template>
                    <template v-for="value in ['registration required', 'open access', 'member privilege']">
                        <base-button class="btn-badge my-1" size="sm" type="primary" icon="fa fa-times-circle" v-if="is_filter_checked('access',value)" v-on:click="filter_remove('access',value)">{{value}}</base-button>
                    </template>
                </div>
            </div>
        </div>
    </section>
    <section class="section section-filter-head py-1">
        <div class="container">
            <div class="row justify-content-center align-items-center">
                <div class="col-lg-12 text-center">
                    <p>
                        <base-button v-if="!search_filters" class="btn-3 btn-filter" type="warning" icon="ni ni-bold-right" v-on:click="search_filters = !search_filters">Advanced Search</base-button>
                        <base-button v-if="search_filters" class="btn-3 btn-filter" type="warning" icon="ni ni-bold-down" v-on:click="search_filters = !search_filters">Advanced Search</base-button>
                        <base-button class="btn-3 btn-reset" type="primary" v-on:click="filter_reset">Reset Filter</base-button>
                    </p>
                </div>
            </div>
        </div>
    </section>
    <transition name="fade">
        <section v-if="search_filters" class="section section-filter py-0 mb-5">
            <div class="container">
                <div class="row mt-3 mb-2">
                    <div class="col-md-1"></div>
                    <div class="col-md-10">
                        <card shadow>
                            <template slot="header">
                                <div class="row">
                                    <div class="col-md-9">
                                        <i>
                                            You can use the following filters {Format, Level, Region, Location, Date, Type, Pathology/Theme, Spinal Regions, Language, Type of access} to refine your search results.
                                        </i>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="pull-right">
                                            <base-button class="btn-3 pull-right" type="link" v-on:click="search_filters = !search_filters">CLOSE</base-button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template slot="footer">
                                <base-button class="btn-3 pull-right" type="link" v-on:click="search_filters = !search_filters">CLOSE</base-button>
                            </template>
                            <form class="form-horizontal">
                                <div class="form-group">
                                    <div class="row">
                                        <label for="inputDATE" class="col-sm-2 control-label">FORMAT</label>
                                        <div class="col-sm-12">
                                            <base-button type="" size="xs" class="btn-badge my-1" v-bind:class="[($route.query.hasOwnProperty('format') == 0) ? 'btn-success' : 'btn-outline-primary']" v-on:click="filter_select_all('format')">All</base-button>
                                            <template v-for="value in categories.format">
                                                <base-button :data-id="value.id" type="" size="xs" class="btn-badge my-1" v-if="value.name.toLowerCase() != 'all'" v-bind:class="[(is_filter_checked('format',value.name)) ? 'btn-success' : 'btn-outline-primary']" v-on:click="filter_append('format',value.name)">{{value.name}}</base-button>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-sm-5">
                                            <label for="inputDATE" class="control-label">LEVEL</label><br/>
                                            <base-button type="" size="xs" class="btn-badge my-1" v-bind:class="[($route.query.hasOwnProperty('level') == 0) ? 'btn-success' : 'btn-outline-primary']" v-on:click="filter_select_all('level')">All</base-button>
                                            <template v-for="value in categories.level">
                                                <base-button :data-id="value.id" type="" size="xs" class="btn-badge my-1" v-if="['Principles'].includes(value.name)" v-bind:class="[(is_filter_checked('level',value.name)) ? 'btn-success' : 'btn-outline-primary']" v-on:click="filter_append('level',value.name)">{{value.name}}</base-button>
                                            </template>
                                            <template v-for="value in categories.level">
                                                <base-button :data-id="value.id" type="" size="xs" class="btn-badge my-1" v-if="['Advanced'].includes(value.name)" v-bind:class="[(is_filter_checked('level',value.name)) ? 'btn-success' : 'btn-outline-primary']" v-on:click="filter_append('level',value.name)">{{value.name}}</base-button>
                                            </template>
                                            <template v-for="value in categories.level">
                                                <base-button :data-id="value.id" type="" size="xs" class="btn-badge my-1" v-if="['Masters'].includes(value.name)" v-bind:class="[(is_filter_checked('level',value.name)) ? 'btn-success' : 'btn-outline-primary']" v-on:click="filter_append('level',value.name)">{{value.name}}</base-button>
                                            </template>
                                            <template v-for="value in categories.level">
                                                <base-button :data-id="value.id" type="" size="xs" class="btn-badge my-1" v-if="!['All','Principles','Advanced','Masters'].includes(value.name)" v-bind:class="[(is_filter_checked('level',value.name)) ? 'btn-success' : 'btn-outline-primary']" v-on:click="filter_append('level',value.name)">{{value.name}}</base-button>
                                            </template>
                                        </div>
                                        <div class="col-sm-7">
                                            <label for="inputDATE" class="control-label">ACCESS TYPE</label><br/>
                                            <base-button type="" size="xs" class="btn-badge my-1" v-bind:class="[($route.query.hasOwnProperty('access') == 0) ? 'btn-success' : 'btn-outline-primary']" v-on:click="filter_select_all('access')">All</base-button>
                                            <template v-for="value in ['registration required', 'open access', 'member privilege']">
                                                <base-button type="" size="xs" class="btn-badge my-1" v-bind:class="[(is_filter_checked('access',value)) ? 'btn-success' : 'btn-outline-primary']" v-on:click="filter_append('access',value)" v-tooltip="configurations[value]">{{value}}</base-button>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <label for="inputPLACE" class="control-label">LOCATION</label>
                                            <br/>
                                            <select v-model="place" @change="placeOnChange()" class="form-control">
                                                <option value="ALL">ALL</option>
                                                <option v-if="value.name != 'ALL'" v-for="(value, key) in categories_place_sortedJson" v-bind:value="value.name" @>
                                                    {{ value.name }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-sm-3">
                                            <label for="inputREGION" class="control-label">REGION</label>
                                            <br/>
                                            <select v-model="region" @change="regionOnChange()" class="form-control">
                                                <option value="ALL">ALL</option>
                                                <option v-if="value.name != 'ALL'" v-for="(value, key) in categories_region_sortedJson" v-bind:value="value.name" @>
                                                    {{ value.name }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-sm-3">
                                            <label for="inputPLACE" class="control-label">START DATE</label>
                                            <br/>
                                            <datepicker v-model="date_start.date" name="date_start" input-class="form-control" @selected="selectedDateStart" @input="inputDateStartAndStop"></datepicker>
                                        </div>
                                        <div class="col-sm-3">
                                            <label for="inputPLACE" class="control-label">END DATE</label>
                                            <br/>
                                            <datepicker v-model="date_stop.date" name="date_stop" input-class="form-control" @selected="selectedDateStop" @input="inputDateStartAndStop"></datepicker>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="row">
                                    </div>
                                </div>
                                <tabs fill class="flex-column flex-md-row">
                                    <card>
                                        <template v-for="category in ['type','pathology', 'anatomical', 'language']">
                                            <tab-pane :title="categories_map[category].toUpperCase()">
                                                <base-button type="" size="sm" class="btn-badge my-1" v-bind:class="[($route.query.hasOwnProperty(category) == 0) ? 'btn-success' : 'btn-outline-primary']" v-on:click="filter_select_all(category)">All</base-button>
                                                <template v-for="(value, key) in categories">
                                                    <template v-for="i in value">
                                                        <template v-if="i.name.toLowerCase() != 'all'">
                                                            <template v-if="category != 'language'">
                                                                <base-button :data-id="i.id" type="" size="xs" class="btn-badge my-1" v-if="key == category" v-bind:class="[(is_filter_checked(category,i.name)) ? 'btn-success' : 'btn-outline-primary']" v-on:click="filter_append(category,i.name)">{{i.name}}</base-button>
                                                            </template>
                                                            <template v-if="category == 'language'">
                                                                <base-button :data-id="i.id" type="" size="xs" class="btn-badge my-1" v-if="key == category" v-bind:class="[(is_filter_checked(category,i.display_name)) ? 'btn-success' : 'btn-outline-primary']" v-on:click="filter_append(category,i.display_name)">{{i.display_name}}</base-button>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </template>
                                            </tab-pane>
                                        </template>
                                    </card>
                                </tabs>
                            </form>
                        </card>
                    </div>
                </div>
                <div class="row justify-content-center align-items-center bottom-btn-form-xs">
                    <div class="col-xs-12 text-center">
                        <base-button class="btn-3" type="danger" v-on:click="search_filters = !search_filters">close filter</base-button>
                        <base-button class="btn-3 " type="primary" v-on:click="filter_reset">Reset Filter</base-button>
                    </div>
                </div>
            </div>
        </section>
    </transition>
    <transition name="fade">
        <section v-if="showcategories" class="section categories mt-4 py-0">
            <div class="container-fluid">
                <div class="row">
                    <template v-for="format in formats">
                        <div @click="categoryClick(format.name)" class="category col-lg-3 col-md-6 col-sm-6 pt-4 pr-3 pb-1 pl-3" v-bind:style="[(format.color.length>=4) ? {'backgroundColor': format.color} : {'backgroundColor': '#29529b'}]">
                            <p class="text-center my-5">
                                <i v-if="format.icon.length >= 4" v-bind:class="'fa ' + format.icon"></i>
                                <i v-if="format.icon.length < 4" class="fa fa-list"></i>
                            </p>
                            <p class="text-right text-uppercase my-0">{{format.name}}</p>
                        </div>
                    </template>
                    <template v-if="loading_categories" v-for="i in (4)">
                        <div class="col-lg-3 my-3">
                            <b-card class="card-post-item loading shadow" header-tag="header" footer-tag="footer">
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                            </b-card>
                        </div>
                    </template>
                </div>
            </div>
        </section>
    </transition>
    <transition name="fade">
        <section v-if="posts_featured.length > 0" class="section features mt-0 pt-0 pb-3">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-12">
                        <h3 class="text-uppercase text-center pt-5 pb-3">highlights</h3>
                    </div>
                </div>
                <div class="row mb-1">
                    <template v-for="(post, key) in posts_featured">
                        <div :data-id="post.id" class="col-lg-3 col-md-6 my-3">
                            <card shadow class="my-3">
                                <template slot="header">
                                    <div class="pull-left ">
                                        <small>
                                            <strong v-on:click="filter_add('format',post.format.name)" class="cursor-pointer">
                                                <i v-if="post.format.icon.length >= 4" v-bind:class="'fa ' + post.format.icon"></i>
                                                <i v-if="post.format.icon.length < 4" class="fa fa-list"></i>
                                                &nbsp;{{post.format.name}}
                                            </strong>
                                        </small>
                                    </div>
                                    <div class="pull-right">
                                        <strong>
                                            <small>
                                                <span v-if="post.day">{{ten_number(post.day)}}</span>&nbsp;<span v-if="post.month">{{getMonth(post.month - 1)}}</span>&nbsp;{{post.year}}
                                            </small>
                                        </strong>
                                    </div>
                                </template>
                                <template slot="footer">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <span class="text-muted"><strong>Level:</strong></span>
                                            <template v-for="(value, key) in post['levels']">
                                                    <span class="ml-1 cursor-pointer" v-on:click="filter_add('level',value.name)"  v-if="value.name.toLowerCase()!='all'">{{value.name.split(' ').join('&nbsp;')}}</span>
                                                    <span class="ml-1 cursor-pointer" v-on:click="filter_select_all('level')"  v-if="value.name.toLowerCase()=='all'">{{value.name.split(' ').join('&nbsp;')}}</span>
                                            </template>
                                            <div class="pull-right">
                                                <router-link :to="{ name: 'article', params: { slug: post.slug } }" class="btn btn-3  btn-primary btn-more-details"> MORE DETAILS </router-link>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row py-1">
                                        <div class="col-md-12">
                                            <span class="text-muted"><strong>Pathology:</strong></span>
                                            <template v-if="post['pathologies'].length > 0">
                                                <span class="ml-1 cursor-pointer" v-on:click="filter_add('pathology',post['pathologies'][0].name)"  v-if="post['pathologies'][0].name.toLowerCase()!='all'">{{post['pathologies'][0].name.split(' ').join('&nbsp;')}}</span>
                                                <span pill variant="dark" class="ml-1 cursor-pointer" v-on:click="filter_select_all('pathology')"  v-if="post['pathologies'][0].name.toLowerCase()=='all'">{{post['pathologies'][0].name.split(' ').join('&nbsp;')}}</span>
                                            </template>
                                            <template v-if="post['pathologies'].length > 1">
                                                ...
                                            </template>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <span class="text-muted"><strong>Location:</strong></span>
                                            <span class="ml-1 cursor-pointer" v-on:click="filter_add('place',post.place.name)"  v-if="post.place.name.toLowerCase()!='all'">{{post.place.name.split(' ').join('&nbsp;')}}</span>
                                            <span class="ml-1 cursor-pointer" v-on:click="filter_select_all('place')"  v-if="post.place.name.toLowerCase()=='all'">{{post.place.name.split(' ').join('&nbsp;')}}</span>
                                        </div>
                                    </div>
                                </template>
                                <router-link :to="{ name: 'article', params: { slug: post.slug } }">
                                    <span class="text-default">{{post.title}}</span>
                                </router-link>
                            </card>
                        </div>
                    </template>
                </div>
            </div>
        </section>
    </transition>
    <section class="section posts py-2">
        <div class="container-fluid">
            <template v-if="total > 0">
                <div class="row">
                    <div class="col-lg-12 pt-4 text-center">
                        <h2 class="text-default">{{total}} results</h2>
                    </div>
                </div>
            </template>
            <div class="row">
                <template v-for="(post, key, index) in posts">

                    <template v-if="key == 0">
                        <div class="col-lg-12 mt-5 mb-4">
                            <h2 v-on:click="filter_add('format',post.format.name)" class="cursor-pointer my-0 py-0" v-bind:style="[(post.format.color.length >= 4) ? {'color': post.format.color} : {'color': '#29529b'}]">
                                <i v-if="post.format.icon.length >= 4" v-bind:class="'fa ' + post.format.icon"></i>
                                <i v-if="post.format.icon.length < 4" class="fa fa-list"></i>
                                &nbsp;{{post.format.name}}
                            </h2>
                        </div>
                    </template>

                    <template v-if="key > 0">
                        <template v-if="posts[key].format.name != posts[key - 1].format.name">
                            <div class="col-lg-12 my-4">
                                <h2 v-on:click="filter_add('format',post.format.name)" class="cursor-pointer my-0 py-0" v-bind:style="[(post.format.color.length >= 4) ? {'color': post.format.color} : {'color': '#29529b'}]">
                                    <i v-if="post.format.icon.length >= 4" v-bind:class="'fa ' + post.format.icon"></i>
                                    <i v-if="post.format.icon.length < 4" class="fa fa-list"></i>
                                    &nbsp;{{post.format.name}}
                                </h2>
                                <hr/>
                            </div>
                        </template>
                    </template>

                    <div :data-id="post.id" class="col-lg-3 col-md-6 my-3">
                        <card class="post my-3">
                            <template slot="header">
                                <div class="pull-left ">
                                    <small>
                                        <span v-on:click="filter_add('format',post.format.name)" class="cursor-pointer" v-bind:style="[(post.format.color.length >= 4) ? {'color': post.format.color} : {'color': '#29529b'}]">
                                            <i v-if="post.format.icon.length >= 4" v-bind:class="'fa ' + post.format.icon"></i>
                                            <i v-if="post.format.icon.length < 4" class="fa fa-list"></i>
                                            &nbsp;{{post.format.name}}
                                        </span>
                                    </small>
                                </div>
                                <div class="pull-right">
                                    <span class="text-default"><small><span v-if="post.day">{{ten_number(post.day)}}</span>&nbsp;<span v-if="post.month">{{getMonth(post.month - 1)}}</span>&nbsp;{{post.year}}</small>
                                    </span>
                                </div>
                            </template>
                            <template slot="footer">
                                <div class="row">
                                    <div class="col-md-12">
                                        <span class="text-default">Level:</span>
                                        <template v-for="(value, key) in post['levels']">
                                                <span class="ml-1 cursor-pointer text-default" v-on:click="filter_add('level',value.name)"  v-if="value.name.toLowerCase()!='all'">{{value.name.split(' ').join('&nbsp;')}}</span>
                                                <span class="ml-1 cursor-pointer text-default" v-on:click="filter_select_all('level')"  v-if="value.name.toLowerCase()=='all'">{{value.name.split(' ').join('&nbsp;')}}</span>
                                        </template>
                                        <div class="pull-right">
                                            <router-link :to="{ name: 'article', params: { slug: post.slug } }" class="btn btn-3 btn-primary btn-more-details"> MORE DETAILS </router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <span class="text-default">Pathology:</span>
                                        <template v-if="post['pathologies'].length > 0">
                                            <span class="ml-1 cursor-pointer text-default" v-on:click="filter_add('pathology',post['pathologies'][0].name)"  v-if="post['pathologies'][0].name.toLowerCase()!='all'">{{post['pathologies'][0].name.split(' ').join('&nbsp;')}}</span>
                                            <span pill variant="dark" class="ml-1 cursor-pointer text-default" v-on:click="filter_select_all('pathology')"  v-if="post['pathologies'][0].name.toLowerCase()=='all'">{{post['pathologies'][0].name.split(' ').join('&nbsp;')}}</span>
                                        </template>
                                        <template v-if="post['pathologies'].length > 1">
                                            ...
                                        </template>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <span class="text-default">Location:</span>
                                        <span class="ml-1 cursor-pointer text-default" v-on:click="filter_add('place',post.place.name)"  v-if="post.place.name.toLowerCase()!='all'">{{post.place.name.split(' ').join('&nbsp;')}}</span>
                                        <span class="ml-1 cursor-pointer text-default" v-on:click="filter_select_all('place')"  v-if="post.place.name.toLowerCase()=='all'">{{post.place.name.split(' ').join('&nbsp;')}}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <span class="text-default">Access type:</span>
                                            <i>
                                                <template v-if="post.access.toLowerCase() == 'registration required'">
                                                    <font-awesome-icon icon="lock" class="access-icon text-danger"/>
                                                    <span class="ml-1 cursor-pointer text-danger" v-on:click="filter_add('access',post.access)">{{post.access}}</span>
                                                </template>
                                                <template v-if="post.access.toLowerCase() == 'open access'">
                                                    <font-awesome-icon icon="lock-open" class="access-icon text-success"/>
                                                    <span class="ml-1 cursor-pointer text-success" v-on:click="filter_add('access',post.access)">{{post.access}}</span>
                                                </template>
                                                <template v-if="post.access.toLowerCase() == 'member privilege'">
                                                    <font-awesome-icon icon="lock" class="access-icon text-primary"/>
                                                    <span class="ml-1 cursor-pointer text-primary" v-on:click="filter_add('access',post.access)">{{post.access}}</span>
                                                </template>
                                            </i>
                                    </div>
                                </div>
                            </template>
                            <router-link :to="{ name: 'article', params: { slug: post.slug } }"class="text-default">
                                <span v-if="post.title.length <= 130">
                                    {{post.title}}
                                </span>
                                <span v-else>
                                    {{post.title.substring(0,130).split(" ").slice(0, -1).join(" ")}} ...
                                </span>
                            </router-link>
                            <div class="mb-1">&nbsp;</div>
                        </card>
                    </div>
                </template>
            </div>
            <template v-if="posts">
                <div class="row no-data" v-if="posts.length == 0 & !loading">
                    <div class="col-lg-12 text-center">
                        <i class="fa fa-frown-o pt-5"></i>
                        <p>NO DATA FOUND</p>
                        <p class="pb-5">
                            <base-button class="btn-3" type="link" v-on:click="filter_reset">Reset Filter</base-button>
                        </p>
                    </div>
                </div>
            </template>
            <div class="row">
                <div v-if="more" class="col-lg-12 text-center">
                    <base-button outline class="btn-3 my-4" type="default" v-on:click="showMore">show more</base-button>
                </div>
                <template v-if="loading" v-for="i in (4)">
                    <div class="col-lg-3 my-3">
                        <b-card class="card-post-item loading shadow" header-tag="header" footer-tag="footer">
                            <p>&nbsp;</p>
                            <p>&nbsp;</p>
                        </b-card>
                    </div>
                </template>
            </div>
        </div>
    </section>
</div>

</template>

<script>

import axios from 'axios'
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import GoTop from '@inotom/vue-go-top';
import Datepicker from 'vuejs-datepicker';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser, faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faUser)
library.add(faLock)
library.add(faLockOpen)

export default {
    components: {
        Tabs,
        TabPane,
        flatPicker,
        GoTop,
        Datepicker,
        library,
        faUser,
        faLock,
        faLockOpen,
        FontAwesomeIcon
    },
    created() {
        window.scrollTo(0, 0);
        this.get_categories()
        this.get_configurations()
        this.init_()
    },
    mounted() {
        this.get_posts_featured()
        if (this.$store.state.subtitle_store)
            this.subtitle = this.$store.state.subtitle_store
        else this.get_page_subtitle()
        if (this.$store.state.posts_store.length > 0 & this.$route.fullPath == this.$store.state.url_store) {
            this.posts = this.$store.state.posts_store
            this.page = this.$store.state.page_store
            this.more = this.$store.state.more_store
            this.total = this.$store.state.total
        } else {
            this.get_posts()
            this.page = 1
            this.$store.commit('page_store', this.page)
            this.$store.commit('more_store', this.more)
            this.$store.commit('total', this.total)
            this.$store.commit('url_store', this.$route.fullPath)
        }
    },
    methods: {
        init_: function() {
            this.terms = ('terms' in this.$route.query ? this.$route.query.terms : "")
            this.place = ('place' in this.$route.query ? this.$route.query.place : "ALL")
            this.region = ('region' in this.$route.query ? this.$route.query.region : "ALL")
            this.date_start.date = ('range' in this.$route.query ? new Date(this.$route.query.range.split(',')[0]) : null)
            this.date_stop.date = ('range' in this.$route.query ? new Date(this.$route.query.range.split(',')[1]) : null)
            if (this.$route.fullPath.replace("/home", "").length > 0) this.showcategories = false
            else this.showcategories = true
        },
        categoryClick: function(format) {
            this.$router.push({
                path: '/',
                query: {
                    format: format
                }
            })
        },
        filter_append: function(key, value, event) {
            var jsonVariable = {}
            if (!(key in this.$route.query)) jsonVariable[key] = value
            if (key in this.$route.query) {
                var array = this.$route.query[key].split(',');
                if (array.indexOf(value) < 0) array.push(value)
                value = array.join()
            }
            jsonVariable[key] = value
            this.$router.push({
                query: Object.assign({}, this.$route.query, jsonVariable)
            })
        },
        filter_add: function(key, value, event) {
            var jsonVariable = {}
            jsonVariable[key] = value
            this.$router.push({
                query: Object.assign({}, this.$route.query, jsonVariable)
            })
        },
        filter_remove: function(key, value, event) {
            let query = Object.assign({}, this.$route.query);
            var values = query[key].split(',')
            values.splice(values.indexOf(value), 1)
            query[key] = values.join(",")
            if (query[key] == '') {
                let query = Object.assign({}, this.$route.query);
                delete query[key];
                this.$router.replace({
                    query
                });
            } else {
                this.$router.replace({
                    query
                })
            }
        },
        filter_select_all: function(key, event) {
            let query = Object.assign({}, this.$route.query);
            delete query[key];
            this.$router.replace({
                query
            });
        },
        is_filter_checked: function(key, value, event) {
            if (this.$route.query.hasOwnProperty(key)) {
                if (this.$route.query[key].split(',').indexOf(value) >= 0) return true
            }
            return false
        },
        filter_reset: function(event) {
            let query = Object.assign({}, this.$route.query);
            query = {}
            this.$router.replace({
                query
            });
            this.init_()
        },
        onEnterClick: function() {
            var jsonVariable = {}
            jsonVariable['terms'] = this.terms
            this.$router.push({
                query: Object.assign({}, this.$route.query, jsonVariable)
            })
            this.get_posts()
        },
        get_page_subtitle() {
            this.error = null
            axios.get(this.api + 'page/subtitle-pages')
                .then(response => {
                    this.subtitle = response.data.content
                    this.$store.state.subtitle_store = this.subtitle
                })
        },
        get_categories() {
            this.error = this.categories = null
            this.loading = true
            this.loading_categories = true;
            axios.get(this.api + 'categories')
                .then(response => {
                    this.loading_categories = false
                    this.loading = false
                    this.categories = response.data
                    this.formats = response.data['format'] || []
                    for (var index in this.categories.place) {
                        var value = this.categories.place[index];
                    }
                    // for (var index in response.data['pathology']) {
                    //     if(response.data['pathology'][index].name == "Metabolic, Inflammatory, Genetic") {
                    //         response.data['pathology'][index].name = "Metabolic; Inflammatory; Genetic";
                    //     }
                    // }
                })
        },
        get_configurations() {
            axios.get(this.api + 'configurations')
                .then(response => {
                    this.configurations = [];
                    for (var index in response.data) {
                        var key = response.data[index].key;
                        var value = response.data[index].value;
                        this.configurations[key] = value;
                    }

                })
        },
        get_posts_featured() {
            this.error = this.posts_featured = null
            this.loading_feaures = true
            var url = this.api + 'contents?qnt=4&featured=true';
            axios.get(url)
                .then(response => {
                    this.loading_feaures = false
                    this.posts_featured = response.data.data || []
                })
        },
        get_posts() {
            this.error = this.posts = null
            this.$store.commit('posts_store', null)
            this.page = 1
            this.$store.commit('page_store', 1)
            this.more = false
            this.$store.commit('more_store', false)
            this.total = 0
            this.$store.commit('total', 0)
            this.loading = true
            let url = this.api + 'contents' + this.$route.fullPath.replace("/home", "");
            // url = url.replace("Metabolic%3B%20Inflammatory%3B%20Genetic", "Metabolic, Inflammatory, Genetic")
            axios.get(url)
                .then(response => {
                    this.posts = response.data.data || []
                    this.$store.commit('posts_store', this.posts)
                    this.total = parseInt(response.data.total)
                    this.$store.commit('total', this.total)
                    this.loading = false
                    if (parseInt(response.data.to) < parseInt(response.data.total)) this.more = true
                    this.$store.commit('more_store', this.more)
                })
        },
        get_append_posts() {
            this.loading = true
            this.more = false
            this.$store.commit('more_store', false)
            var page = "?page=" + (parseInt(this.page) + 1)
            if (Object.keys(this.$route.query).length > 0) page = "&page=" + (parseInt(this.page) + 1)
            this.page = parseInt(this.page) + 1
            this.$store.commit('page_store', this.page)
            let url = this.api + 'contents' + this.$route.fullPath.replace("/home", "") + page;
            // url = url.replace("Metabolic%3B%20Inflammatory%3B%20Genetic", "Metabolic, Inflammatory, Genetic")
            axios.get(url)
                .then(response => {
                    let posts = response.data.data || []
                    posts.forEach(post => {
                        this.posts.push(post)
                    })
                    this.$store.commit('posts_store', this.posts)
                    this.loading = false
                    if (parseInt(response.data.to) < parseInt(response.data.total)) this.more = true
                    this.$store.commit('more_store', this.more)
                })
        },
        rangeInput() {
            var jsonVariable = {}
            jsonVariable['range'] = this.range.value.replace(" to ", ",")
            this.$router.push({
                query: Object.assign({}, this.$route.query, jsonVariable)
            })
        },
        optionsChangeSortby(value) {
            var jsonVariable = {}
            jsonVariable['sortby'] = value
            this.$router.push({
                query: Object.assign({}, this.$route.query, jsonVariable)
            })
        },
        showMore() {
            this.get_append_posts()
        },
        calc_fontSize(value) {
            var size = 1;
            if (value < 30) size = 2;
            return size;
        },
        placeOnChange() {
            if (this.place == 'ALL')
                this.filter_select_all('place')
            else
                this.filter_add('place', this.place)
        },
        regionOnChange() {
            if (this.region == 'ALL')
                this.filter_select_all('region')
            else
                this.filter_add('region', this.region)
        },
        dateOnDate() {
            var currentDate = new Date();
            var since_today = currentDate.getFullYear() + '-' + currentDate.getMonth() + 1 + '-' + currentDate.getDate() + ',' + '2050-01-01'
            var before_today = '1900-01-01' + ',' + currentDate.getFullYear() + '-' + currentDate.getMonth() + 1 + '-' + currentDate.getDate()
        },
        selectedDateStart(value) {
            console.log("selectedDateStart")
            if (!this.date_stop.date) {
                let result = new Date(value.getFullYear(), value.getMonth(), value.getDate() + 7)
                this.date_stop.date = result
            }
        },
        selectedDateStop(value) {
            console.log("selectedDateStop")
            if (!this.date_start.date) {
                let result = new Date(value.getFullYear(), value.getMonth(), value.getDate() - 7)
                this.date_start.date = result
            }
        },
        inputDateStartAndStop() {
            console.log("inputDateStart")
            let date_start = [this.date_start.date.getFullYear(), this.ten_number(this.date_start.date.getMonth() + 1), this.ten_number(this.date_start.date.getDate())].join("-")
            let date_stop = [this.date_stop.date.getFullYear(), this.ten_number(this.date_stop.date.getMonth() + 1), this.ten_number(this.date_stop.date.getDate())].join("-")
            console.log(date_start)
            console.log(date_stop)
            this.filter_add('range', date_start + ',' + date_stop)
        },
        ten_number(value) {
            // if (parseInt(value) < 10) return '0' + value
            return value
        },
        sortArrays(arrays) {
            arrays.sort(function(x, y) {
                return y.name < x.name;
            });
            return arrays;
        },
        getMonth(value) {
            let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
            return months[value]
        }
    },
    computed: {
        years() {
                const year = (new Date().getFullYear())
                return Array.from({
                    length: 10
                }, (value, index) => (year - 9) + index).reverse()
            },
            categories_place_sortedJson: function() {
                return this.categories.place.sort((t1, t2) => t1.name < t2.name ? -1 : 1);
            },
            categories_region_sortedJson: function() {
                return this.categories.region.sort((t1, t2) => t1.name < t2.name ? -1 : 1);
            }
    },
    head: {
        title: function() {
            return {
                inner: 'SEARCH'
            }
        }
    },
    data() {
        return {
            api: require('../../package.json').api,
            configurations: null,
            categories: null,
            categories_map: {
                'format': 'format',
                'type': 'type',
                'level': 'level',
                'pathology': 'pathology/theme',
                'anatomical': 'spinal regions',
                'language': 'language'
            },
            date_start: {
                date: null
            },
            date_stop: {
                date: null
            },
            error: null,
            formats: null,
            loading: false,
            loading_categories: false,
            loading_feaures: false,
            more: false,
            page: 0,
            place: null,
            posts: [],
            posts_featured: [],
            region: null,
            search_filters: false,
            showcategories: true,
            subtitle: '',
            terms: null,
            title: '',
            total: 0,
        }
    },
    watch: {
        '$route' (to, from) {
            this.$store.commit('posts_store', [])
            this.$store.commit('url_store', this.$route.fullPath)
            this.get_posts()
            if (this.$route.fullPath.replace("/home", "").length > 0) this.showcategories = false
            else this.showcategories = true
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/views/Home.vue